import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import compose from 'recompose/compose';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddPropertyMainData from './AddPropertyMainData';
import AddPropertySecondData from './AddPropertySecondData';
import axios from 'axios';
// Auth
// import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
// import withAuth from 'components/Auth/withAuth.jsx';

const styles = theme => ({
  root: {
    width: '90%',
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

function getSteps() {
  return ['Main data', 'Participants', 'Assets', 'Confirm', 'End'];
}


class AddPropertyStepper extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.state = {
        formControls: {
            name: {
              value: '',
              placeholder: 'Name'
            },
            name_public: {
              value: '',
              placeholder: 'Public name'
            },
            notes:{
              value: ''
            },
            description: {
              value: ''
            },
            short_description: {
              value: ''
            },
            short_description_public: {
              value: ''
            },
            description_public: {
              value: ''
            },
            price:{
              value: ''
            },
            card:{
              value: 0
            },
            currency:{
              value: 'EU'
            }
        },
        activeStep: 0,
        skipped: new Set(),

    }

  }


  isStepOptional = step => step === 2;

  handleNext = () => {
    const { activeStep } = this.state;
    let { skipped } = this.state;
    if (this.isStepSkipped(activeStep)) {
      skipped = new Set(skipped.values());
      skipped.delete(activeStep);
    }
    this.setState({
      activeStep: activeStep + 1,
      skipped,
    });
  };

  handleSubmit = () => {
    const newProperty = this.state.formControls;
    const confirm = this.props.confirm;

    var property =  {
      name: newProperty.name.value,
      notes: newProperty.notes.value,
      description: newProperty.description.value,
      price: newProperty.price.value,
      currency: newProperty.currency.value,
      test: "test"
    };

    console.log({newProperty, confirm, property });

    axios
      .post('/api/v1/properties.json', property, {headers:{ Authorization: 'Bearer ' + confirm }})
      .then((response) => {
        alert('Property Added!');
        const savedProperty = response.data;
        const { history } = this.props;
        history.push(`/properties/${savedProperty.id}`);
      })
      .catch((error) => {
        console.log(error);
      });
    console.log('submitted');
    this.handleNext();
  };



  changeHandler = event => {
    const name = event.target.id;
    const value = event.target.value;

    const updatedControls = {
      ...this.state.formControls
    };
    const updatedFormElement = {
      ...updatedControls[name]
    };

    console.log(event.target);

    updatedFormElement.value = value;
    updatedFormElement.touched = true;

    // Validations
    // updatedFormElement.valid = validate(value, updatedFormElement.validationRules);

    updatedControls[name] = updatedFormElement;

    this.setState({
      formControls: updatedControls
    });

  };


  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleSkip = () => {
    const { activeStep } = this.state;
    if (!this.isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    this.setState(state => {
      const skipped = new Set(state.skipped.values());
      skipped.add(activeStep);
      return {
        activeStep: state.activeStep + 1,
        skipped,
      };
    });
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  isStepSkipped(step) {
    return this.state.skipped.has(step);
  }

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;

    return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const props = {};
            const labelProps = {};
            if (this.isStepOptional(index)) {
              labelProps.optional = <Typography variant="caption">Optional</Typography>;
            }
            if (this.isStepSkipped(index)) {
              props.completed = false;
            }
            return (
              <Step key={label} {...props}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>

        <form className={classes.form} onSubmit={this.handleSubmit}>

          <div>
            {activeStep === steps.length ? (
              <div>
                <Typography className={classes.instructions}>
                  All steps completed - you&apos;re finished
                </Typography>
                <Button onClick={this.handleReset} className={classes.button}>
                  Reset
                </Button>
              </div>
            ) : (

              <div>

              {/* FormsControls */}

              {
                {
                  0: <AddPropertyMainData changeHandler={this.changeHandler.bind(this)} propertyData={this.state.formControls}/>,
                  1: <AddPropertySecondData changeHandler={this.changeHandler.bind(this)} propertyData={this.state.formControls}/>,
                  2: <AddPropertySecondData changeHandler={this.changeHandler.bind(this)} propertyData={this.state.formControls}/>,
                  3: "Confirmation",
                  4: "Success",
                  default: 'Unknown step'
                }[activeStep]
              }

              {/* End FormsControls */}

                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={this.handleBack}
                    className={classes.button}
                  >
                    Back
                  </Button>
                  {this.isStepOptional(activeStep) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleSkip}
                      className={classes.button}
                    >
                      Skip
                    </Button>
                  )}
                  { activeStep === steps.length - 1 ?
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSubmit(this.state.formControls)}
                        className={classes.button}
                      >
                        Finish
                      </Button>

                      :

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      >
                        Next
                      </Button>
                    }
                </div>
              </div>

            )}
          </div>

        </form>

      </div>
    );
  }
}

AddPropertyStepper.propTypes = {
  classes: PropTypes.object,
  // property: PropTypes.shape(),
};


export default compose(
  // withAuth,
  withStyles(styles),
  withRouter
)(AddPropertyStepper);
